module.exports = __webpack_public_path__ + "static/Fellix-Bold-747abce8e9d678129a0e35495885ee61.eot";